import React from 'react'
import AboutUs from '../fetures/about-us/AboutUs'

const AboutUsPage = () => {
  return (
    <AboutUs/>
  )
}

export default AboutUsPage